import React from 'react';
import { X, MapPin, Calendar, Star, ChevronRight } from 'lucide-react';
import { formatEventDay } from '../utils/formatEventDay';

const VenueEventsDrawer = ({ venue, isOpen, onClose, onEventClick }) => {
  if (!isOpen || !venue) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-end justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/60"
        onClick={onClose}
      />
      {/* Drawer */}
      <div className="relative w-full max-w-md glass-dark rounded-t-3xl max-h-[85vh] overflow-y-auto animate-slide-up">
        {/* Handle */}
        <div className="flex justify-center pt-3 pb-2">
          <div className="w-10 h-1 bg-white/30 rounded-full" />
        </div>
        {/* Header */}
        <div className="flex items-start justify-between px-5 pb-4">
          <div>
            <span className="text-white/60 text-sm">Eventos en</span>
            <h2 className="text-white text-2xl font-bold">{venue.name}</h2>
            <div className="flex items-center gap-1.5 text-white/60 text-sm mt-1">
              <MapPin size={14} />
              <span>{venue.location}</span>
            </div>
            <p className="text-white/50 text-sm mt-1">{venue.description}</p>
          </div>
          <button onClick={onClose} className="glass-dark w-9 h-9 rounded-full flex items-center justify-center text-white">
            <X size={18} />
          </button>
        </div>
        {/* Events List */}
        <div className="px-5 pb-8 space-y-3">
          {venue.events.map((event) => (
            <button
              key={event.id}
              onClick={() => onEventClick(event)}
              className="glass-dark w-full flex items-center gap-3 rounded-2xl p-4 transition-transform active:scale-[0.98]"
            >
              <div className="glass-dark w-12 h-12 rounded-xl flex items-center justify-center shrink-0">
                <Calendar size={20} className="text-white" />
              </div>
              <div className="flex-1 text-left min-w-0">
                <span className="inline-block text-[10px] font-bold text-white px-2 py-0.5 rounded glass-dark mb-1">
                  {formatEventDay(event.day)}
                </span>
                <h4 className="text-white font-bold text-sm truncate">{event.name}</h4>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-white font-bold text-sm whitespace-nowrap no-underline" style={{ textDecoration: 'none' }}>{`${event.price.toFixed(2)}€`}</span>
                  <div className="flex items-center gap-0.5">
                    <Star size={10} className="text-[#F82C47] fill-[#F82C47]" />
                    <span className="text-[#F82C47] text-xs font-medium">+{event.points}</span>
                  </div>
                </div>
              </div>
              <ChevronRight size={20} className="text-white/60 shrink-0" />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VenueEventsDrawer;
